import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { ParallaxBanner } from "react-scroll-parallax";
import StatementBox from "components/universal/statement_box";
import { Row2 } from "values/text/home";
import { white_color } from "styles/theme";
import { primary_color } from "styles/theme";
import { xsLargePictureAreaStyle } from "styles/general";
import Pic1 from "static/pic1.webp";
import { heroVisionContainerStyle } from "styles/home_page/vision";
import { heroVisionContainerInnerWrapperStyle } from "styles/home_page/vision";
import { heroVisionImageInnerWrapperStyle } from "styles/home_page/vision";
import { heroVisionXsImageStyle } from "styles/home_page/vision";
import { heroVisionImageLayersStyle } from "styles/home_page/vision";

export default function Vision(){
    return (
        <Box sx={[xsLargePictureAreaStyle, heroVisionContainerStyle]}>
            <Grid container sx={heroVisionContainerInnerWrapperStyle}>
                <Grid item xs={12}>
                    <Box sx={heroVisionImageInnerWrapperStyle}>
                        <ParallaxBanner 
                            style={heroVisionXsImageStyle}
                            layers={[{
                                image: Pic1,
                                translateX: [0, -30],
                                shouldAlwaysCompleteAnimation: true,
                                expanded: false,
                                style: heroVisionImageLayersStyle
                            }]}>
                        </ParallaxBanner>
                    </Box>
                </Grid>
                <StatementBox 
                    title={Row2.TITLE}
                    subtitle1={Row2.SUBTITLE_1}
                    subtitle2={Row2.SUBTITLE_2}
                    subtitle3={Row2.SUBTITLE_3}
                    paragraph={Row2.PARAGRAPH_1}
                    text_color={white_color}
                    background_color={primary_color}
                    border_color={white_color} 
                    paddingTop={10}
                    paddingBottom={10}
                    is_phone={true} />
            </Grid>
        </Box>
    )
}